<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }} #{{id}}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="ID">
          <b-input placeholder="ID" disabled v-model="model.id"></b-input>
        </b-field>
        <b-field label="Пароль">
          <b-input
            type="password"
            icon="key"
            password-reveal
            placeholder="Пароль"
            v-model="model.password"></b-input>
        </b-field>
        <b-field label="Повторите пароль"
          :type="{'is-danger': errors.has('confirm-password')}"
          :message="[{
            'Пароль обязательное поле для заполнения' : errors.firstByRule('confirm-password', 'required'),
            'Введенные пароль не совпадают' : errors.firstByRule('confirm-password', 'is')
          }]">
          <b-input placeholder="Повторите пароль"
            type="password"
            icon="key"
            name="confirm-password"
            password-reveal
            v-model="confirmPassword"
            v-validate="{ required: true, is: model.password }">
          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

import { EventBus } from '@/utils'

export default {
  name: 'UserPasswordForm',
  components: {
    //
  },
  props: {
    id: Number,
    title: String
  },
  data: function () {
    return {
      confirmPassword: '',
      model: {
        id: undefined,
        password: ''
      }
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this
    if (this.id){
      this.model.id = this.id
    }
    //
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: $this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    doUpdate () {
      let $this = this
      if ($this.id){
        $this.$store.dispatch('changePasswordUser', $this.model)
      }
    }
    
  }
}
</script>

<style scoped>
</style>
<style>
</style>